'use strict';

module.exports = /*@ngInject*/ function() {
    var factory = {};
    var storage = new Map();
    factory.save = function(id, series){
        storage.set(id, series);
    };
    factory.get = function(id){
        return storage.get(id);
    };
    factory.clear = function(id) {
        "use strict";
        storage.delete(id);
    };
    return factory;
};